// extracted by mini-css-extract-plugin
export default {"LabelWrapper":"CalendarCellActionLabel_LabelWrapper__6J+4Y","LabelText":"CalendarCellActionLabel_LabelText__gP-7t","ActionWrapper":"CalendarCellActionLabel_ActionWrapper__i-yTI"};